import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanChequeUpdateModalUI from './LoanChequeUpdateModalUI'

class LoanChequeUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      messageList: [],
      // form fields
      chequeBounceId: '',
      chequeNumber: '',
      chequeNumberError: null,
      bounceReason: '',
      bounceReasonError: null,
      bounceDate: '',
      bounceDateError: null,
      bankName: '',
      bankNameError: null,
      branchName: '',
      branchNameError: null,
      amount: '',
      amountError: null,
      closureStatus: '',
      closureStatusError: null
    }
  }

  componentDidUpdate(prevProps) {
    // When selectedCheque changes, update the state
    if (this.props.selectedCheque !== prevProps.selectedCheque && this.props.selectedCheque) {
      this.setState({
        chequeBounceId: this.props.selectedCheque.chequeBounceId,
        chequeNumber: this.props.selectedCheque.chequeNumber || '',
        bounceReason: this.props.selectedCheque.bounceReason || '',
        bounceDate: this.props.selectedCheque.bounceDate || '',
        bankName: this.props.selectedCheque.bankName || '',
        branchName: this.props.selectedCheque.branchName || '',
        amount: this.props.selectedCheque.amount ? this.props.selectedCheque.amount.toString() : '',
        closureStatus: this.props.selectedCheque.closureStatus || '',
        // Clear previous errors
        chequeNumberError: null,
        bounceReasonError: null,
        bounceDateError: null,
        bankNameError: null,
        branchNameError: null,
        amountError: null,
        closureStatusError: null,
        errorList: []
      })
    }
  }

  render() {
    let closureStatusList = [
        { key: 'Select status', value: 'Select Status' },
        { key: 'open', value: 'Open' },
        { key: 'close', value: 'Close' },
        { key: 'pending_for_closure', value: 'Pending For Closure' }
      ]      
    return (
      <LoanChequeUpdateModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        messageList={this.state.messageList}
        // modes
        updateMode={this.props.updateMode}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        chequeNumber={this.state.chequeNumber}
        onChequeNumberChange={(event) => { this.setState({ chequeNumber: event.target.value }) }}
        chequeNumberError={this.state.chequeNumberError}
        setChequeNumberError={(error) => { this.setState({ chequeNumberError: error }) }}
        bounceReason={this.state.bounceReason}
        onBounceReasonChange={(event) => { this.setState({ bounceReason: event.target.value }) }}
        bounceReasonError={this.state.bounceReasonError}
        setBounceReasonError={(error) => { this.setState({ bounceReasonError: error }) }}
        bounceDate={this.state.bounceDate}
        onBounceDateChange={(dateISO) => { this.setState({ bounceDate: dateISO }) }}
        bounceDateError={this.state.bounceDateError}
        setBounceDateError={(error) => { this.setState({ bounceDateError: error }) }}
        bankName={this.state.bankName}
        onBankNameChange={(event) => { this.setState({ bankName: event.target.value }) }}
        bankNameError={this.state.bankNameError}
        setBankNameError={(error) => { this.setState({ bankNameError: error }) }}
        branchName={this.state.branchName}
        onBranchNameChange={(event) => { this.setState({ branchName: event.target.value }) }}
        branchNameError={this.state.branchNameError}
        setBranchNameError={(error) => { this.setState({ branchNameError: error }) }}
        amount={this.state.amount}
        onAmountChange={(event) => { this.setState({ amount: event.target.value }) }}
        amountError={this.state.amountError}
        setAmountError={(error) => { this.setState({ amountError: error }) }}
        closureStatusList={closureStatusList}
        closureStatus={this.state.closureStatus}
        onClosureStatusChange={(event) => { this.setState({ closureStatus: event.target.value }) }}
        closureStatusError={this.state.closureStatusError}
        setClosureStatusError={(error) => { this.setState({ closureStatusError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.validateForm()) {
      return 
    }

    this.setState({
      successMsg: null,
      errorList: [],
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/chequeBounces/${this.state.chequeBounceId}`,
      this.onSubmitCallback, {
        chequeNumber: this.state.chequeNumber,
        bounceReason: this.state.bounceReason,
        bounceDate: this.state.bounceDate,
        bankName: this.state.bankName,
        branchName: this.state.branchName,
        amountF: this.state.amount,
        closureStatus: this.state.closureStatus
      }
    )
  }

  validateForm = () => {
    let hasErrors = false
    const newErrorsObj = {}
    const newErrorsList = []

    if (!this.state.chequeNumber) {
      newErrorsObj.chequeNumberError = 'Cheque Number is required'
      newErrorsList.push('Cheque Number is required')
      hasErrors = true
    }

    if (!this.state.bounceReason) {
      newErrorsObj.bounceReasonError = 'Bounce Reason is required'
      newErrorsList.push('Bounce Reason is required')
      hasErrors = true
    }

    if (!this.state.bounceDate) {
      newErrorsObj.bounceDateError = 'Bounce Date is required'
      newErrorsList.push('Bounce Date is required')
      hasErrors = true
    }

    if (!this.state.bankName) {
      newErrorsObj.bankNameError = 'Bank Name is required'
      newErrorsList.push('Bank Name is required')
      hasErrors = true
    }
    
    if (!this.state.branchName) {
      newErrorsObj.branchNameError = 'Branch Name is required'
      newErrorsList.push('Branch Name is required')
      hasErrors = true
    }

    if (!this.state.amount) {
      newErrorsObj.amountError = 'Amount is required'
      newErrorsList.push('Amount is required')
      hasErrors = true
    } else if (isNaN(parseFloat(this.state.amount))) {
      newErrorsObj.amountError = 'Amount must be a valid number'
      newErrorsList.push('Amount must be a valid number')
      hasErrors = true
    }

    if (!this.state.closureStatus || this.state.closureStatus === 'Select status') {
        newErrorsObj.closureStatusError = 'Status is required'
        newErrorsList.push('Status is required')
        hasErrors = true
      }

    this.setState({
      ...newErrorsObj,
      errorList: newErrorsList
    })

    return hasErrors
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
    })

    if (!response.errorList || response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null,
          chequeBounceId: '',
          chequeNumber: '',
          chequeNumberError: null,
          bounceReason: '',
          bounceReasonError: null,
          bounceDate: '',
          bounceDateError: null,
          bankName: '',
          bankNameError: null,
          branchName: '',
          branchNameError: null,
          amount: '',
          amountError: null,
          closureStatus: '',
          closureStatusError: null,
          errorList: []
        })
        this.props.onRefreshClick()
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(LoanChequeUpdateModalSF)